import axios from 'axios'
import { API_ADDRESS } from 'config'
import { CouncilsOwner } from 'state/types'


const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
const config = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${tokenData?.token ?? ''}`,
  },
}

export const getOwnerStats = async (state = ''): Promise<CouncilsOwner[]> => {
  const abortController = new AbortController()
  const url = state.length > 0 ? `${API_ADDRESS}/admin/councils/list-owners?state=${state}` : `${API_ADDRESS}/admin/councils/list-owners`
  const options = {state, brokenListings: false, brokenProperties: false}
  if (window.location.href.includes('broken-listings')) {
    options.brokenListings = true;
  }
  if (window.location.href.includes('broken-properties')) {
    options.brokenProperties = true;
  }

  const customConfig = {
    ...config,
    method: "POST",
    body: JSON.stringify(options)
  }
  const response = await fetch(url, customConfig)
  const data = await response.json()
  // const { data } = await axios.get(url)
  return data
}

interface CreateCouncilPropertiesResponse {
  status: string
  message: string
  errors?: string[]
}

export const createCouncilProperties = async (ownerId, upload): Promise<CreateCouncilPropertiesResponse> => {
  const url = `${API_ADDRESS}/admin/councils/upload-properties?ownerId=${ownerId}`
  /*
  console.log("createCouncilProperties upload", upload)
  */
  const { data } = await axios.post(url, upload)

  return data
}

interface CreateCouncilPropertyResponse {
  status: string
  message: string
  errors?: string[]
}

export const createCouncilProperty = async (ownerId, upload): Promise<CreateCouncilPropertyResponse> => {
  const url = `${API_ADDRESS}/admin/councils/upload-property?ownerId=${ownerId}`
  /*
  console.log("createCouncilProperty upload", upload)
  */
  const { data } = await axios.post(url, upload)

  return data
}
